import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'

import GRDialogTitle from '../../../components/GRDialogTitle/GRDialogTitle'
import { UnsavedChangesGuard } from '../../hooks/useUnsavedChangesGuard'

type UnsavedChangesDialogProps = {
  // Opens the dialog while it holds a navigation, and cancels or proceeds with it unless the handlers are given.
  guard?: UnsavedChangesGuard
  open?: boolean
  title?: string
  text?: string
  discardText?: string
  saveText?: string
  onCancel?: () => void
  onDiscard?: () => void
  // Without it the dialog offers only Cancel and Discard.
  onSave?: () => void
}

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({
  guard,
  open = !!guard?.isBlocked,
  title,
  text,
  discardText,
  saveText,
  onCancel = guard?.cancel,
  onDiscard = guard?.proceed,
  onSave,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <GRDialogTitle onClose={onCancel}>{title ?? t('internal-common:unsaved_changes_title')}</GRDialogTitle>
      <DialogContent dividers>
        <Typography>{text ?? t('internal-common:unsaved_changes_text')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('internal-common:cancel')}</Button>
        <Button color="error" onClick={onDiscard}>
          {discardText ?? t('internal-common:unsaved_changes_discard')}
        </Button>
        {onSave && (
          <Button variant="contained" onClick={onSave}>
            {saveText ?? t('internal-common:unsaved_changes_save')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
